module.exports = __webpack_public_path__ + "img/149.12397a29.jpg";